export const DEVELOPMENT_API_BASE_URL = "http://localhost:4000/api/v1";
const forbiddenProductionHosts = new Set(["localhost", "127.0.0.1", "10.0.2.2", "::1"]);

export function resolveApiBaseUrl(configuredValue?: string, production = false): string {
  const configured = configuredValue?.trim();
  if (!configured) {
    if (production) throw new Error("VITE_API_BASE_URL is required for a production web build");
    return DEVELOPMENT_API_BASE_URL;
  }
  const normalized = configured.replace(/\/$/, "");
  if (production) {
    let url: URL;
    try {
      url = new URL(normalized);
    } catch {
      throw new Error("VITE_API_BASE_URL must be a valid HTTPS URL in production");
    }
    if (url.protocol !== "https:" || forbiddenProductionHosts.has(url.hostname.toLowerCase()))
      throw new Error("VITE_API_BASE_URL must be a public HTTPS URL in production");
  }
  return normalized;
}
